import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';
import { LoaderService } from '../edduca-imob';

@Injectable()
export class LoaderInterceptorService implements HttpInterceptor {

    _counter = 0;

    constructor(private loaderService: LoaderService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const loaderHeaderKey = 'loader';
        const hasLoaderHeader = req.headers.has(loaderHeaderKey);

        let clonedReq = req;

        if (hasLoaderHeader) {
            this.showLoader();

            // Remover o cabeçalho corretamente
            const newHeaders = req.headers.delete(loaderHeaderKey);
            clonedReq = req.clone({ headers: newHeaders });
        }
        
        return next.handle(clonedReq).pipe(
            catchError((error) => {
                if (hasLoaderHeader) this.hideLoader();
                throw error;
            }),
            finalize(() => {
                if (hasLoaderHeader) this.hideLoader();
            })
        );
    }

    showLoader() {
        //if (this._counter < 0) this._counter = 1;
        this._counter++;
        this.loaderService.showLoader();
    }

    hideLoader() {
        this._counter--;
        if (this._counter <= 0)
            this.loaderService.hideLoader()
    }

}